'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ServiceDescriptor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _MethodDescriptor = require('./MethodDescriptor');

var _MethodType = require('./MethodType');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ServiceDescriptor = exports.ServiceDescriptor = function () {
    function ServiceDescriptor(serviceName, getModel) {
        _classCallCheck(this, ServiceDescriptor);

        this.serviceName = _auroraJavascriptUtils.assert.string(serviceName);
        this.getModel = _auroraJavascriptUtils.assert.func(getModel);
        this.methods = {};
    }

    _createClass(ServiceDescriptor, [{
        key: 'getMethodDescriptor',
        value: function getMethodDescriptor(methodName) {
            _auroraJavascriptUtils.assert.string(methodName);

            var methodDescriptor = this.methods[methodName];
            if (!methodDescriptor) {
                throw new Error('couldn\'t find method \'' + methodName + '\' in service \'' + this.serviceName + '\'');
            }

            return methodDescriptor;
        }
    }, {
        key: 'createCommandDecorator',
        value: function createCommandDecorator(meta) {
            return this._createDecorator(_MethodType.MethodType.COMMAND, meta);
        }
    }, {
        key: 'createQueryDecorator',
        value: function createQueryDecorator(meta) {
            return this._createDecorator(_MethodType.MethodType.QUERY, meta);
        }
    }, {
        key: '_createDecorator',
        value: function _createDecorator(methodType, meta) {
            var _this = this;

            _auroraJavascriptUtils.assert.object(meta);
            _auroraJavascriptUtils.assert.checkArgument(!!meta.request);
            _auroraJavascriptUtils.assert.checkArgument(!!meta.response);

            var requestModelConstructor = this.getModel(meta.request);
            var responseModelConstructor = this.getModel(meta.response);

            return function (target, key, descriptor) {
                if (_this.methods[key]) {
                    throw new Error('service \'' + _this.serviceName + '\' already have method descriptor \'' + key + '\'');
                }

                var originalMethod = descriptor.value;

                var methodDescriptor = _this.methods[key] = new _MethodDescriptor.MethodDescriptor(_this, key, methodType, { request: requestModelConstructor, response: responseModelConstructor }, originalMethod);

                descriptor.value = function overridenMethod(rawRequest) {
                    var service = this;

                    var call = methodDescriptor.createCall(rawRequest, service);
                    if (methodType === _MethodType.MethodType.QUERY) {
                        // query methods executed immediately after creation
                        call.execute();
                    }
                    return call;
                };

                return descriptor;
            };
        }
    }]);

    return ServiceDescriptor;
}();


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/rpc/ServiceDescriptor.js
// module id = 1423
// module chunks = 118